import { Controller, Application } from 'stimulus';
import $ from 'jquery';

class FormController extends Controller {
  static targets = ['form', 'submitButton'];

  declare readonly formTarget: HTMLFormElement;
  declare readonly submitButtonTarget: HTMLInputElement;

  initialize(): void {
    this.initFormEventListeners();
  }

  private initFormEventListeners() {
    this.formTarget.addEventListener('submit', () => {
      if ($(this.formTarget).valid()) {
        this.submitButtonTarget.setAttribute("disabled", "disabled");
      }
    });
  }
}

export function registerForm(application: Application): void {
  application.register('form', FormController);
}
